import { Component } from '@angular/core';
import { ApresentationComponent } from './apresentation/apresentation.component';
import { HeaderComponent } from '../commons/header/header.component';
import { FooterComponent } from '../commons/footer/footer.component';
import { SinopseComponent } from './sinopse/sinopse.component';
import { QrcodeComponent } from './qrcode/qrcode.component';
import { PreviewComponent } from './preview/preview.component';
import { DepoimentosComponent } from './depoimentos/depoimentos.component';
import { CompraComponent } from './compra/compra.component';
import { AutorComponent } from './autor/autor.component';

@Component({
  standalone: true,
  imports: [HeaderComponent, FooterComponent, ApresentationComponent, SinopseComponent, QrcodeComponent, PreviewComponent, DepoimentosComponent, CompraComponent, AutorComponent],
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {}

